import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Table, Accordion } from "react-bootstrap";
import "./_buildingCreationHome.scss";
import HostelRoomAttendanceSection from './HostelRoomAttendanceSection';
import BuildingCreationSection from './buildingCreationSection';

class BuildingCreationHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            blockType: "buildingCreation",
        };
    }

    handleSelect(val) {
        this.setState({
            blockType: val
        })
    }

    render() {

        return (
            <>
                <section className="student-table">
                    <Container className="buildingCreationHome mt-3">
                        <Row>
                            <div style={{ marginLeft: "200px" }} className="building_CreationCard">
                                <Col sm={5}>
                                    <Card className={this.state.blockType === "buildingCreation" ? "active block_view" : "block_view"} onClick={() => this.handleSelect("buildingCreation")}>
                                        <Card.Body style={{ backgroundColor: "#F6FDFF", color: "#2bc48a" }}>
                                            <h6 className="text-center">
                                                <span className="title_alignment text-center mr-2">Building Creation</span>
                                            </h6>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </div>
                            <div>
                                <Col sm={7}>
                                    <Card className={this.state.blockType === "studentAllocation" ? "active block_view1" : "block_view1"} onClick={() => this.handleSelect("studentAllocation")}>
                                        <Card.Body style={{ backgroundColor: "#FFF5E8", color: "#FF9917" }}>
                                            <h6 className="text-center">
                                                <span className="title_alignment text-center mr-2">Student Allocation</span>
                                            </h6>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </div>
                        </Row>

                        {

                            this.state.blockType === "buildingCreation" ? (
                                < BuildingCreationSection globals={this.props.globals} getNewEducationalStudents={this.props.getNewEducationalStudents} studentCreationModal={this.state.studentCreationModal} />
                            ) : ("")

                        }

                        {
                            this.state.blockType === "studentAllocation" ? (
                                < HostelRoomAttendanceSection globals={this.props.globals} getNewEducationalStudents={this.props.getNewEducationalStudents} studentCreationModal={this.state.studentCreationModal} />
                            ) : ("")
                        }
                    </Container>
                </section>
            </>
        );
    }
}
export default BuildingCreationHome;